const DOCUMENT_REPOSITORY_DROP_SELECTOR = '[data-document-drop-zone="true"]';

/**
 * Project document repositories have their own uploader. The application-wide
 * chemistry drop handler must not reinterpret those drops as molecule imports.
 */
export const isDocumentRepositoryDropTarget = (target: EventTarget | null): boolean => {
  return target instanceof Element && target.closest(DOCUMENT_REPOSITORY_DROP_SELECTOR) !== null;
};
